import { useState, useCallback } from "react";
import { fetchSheetPrices, fetchAllSheetPrices } from "./googleSheets";

/* ─── Hook ───────────────────────────────────────────────────── */
export const usePrices = () => {
  const [prices, setPrices]           = useState({});   // "SYM:CAT" → price
  const [usdtry, setUsdtry]           = useState(null);
  const [loading, setLoading]         = useState(false);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [sheetOk, setSheetOk]         = useState(null);

  /* Cached lookup */
  const getPrice = useCallback(
    (symbol, category) => prices[`${symbol}:${category}`] ?? null,
    [prices]
  );

  /**
   * Tek sembol için fiyat.
   * Önce cache → sonra o kategorinin sheet sayfası.
   */
  const fetchSinglePrice = useCallback(async (symbol, category) => {
    const cached = prices[`${symbol}:${category}`];
    if (cached != null) return cached;

    const { prices: sheetData } = await fetchSheetPrices(category);
    if (Object.keys(sheetData).length > 0) {
      setPrices((prev) => ({ ...prev, ...sheetData }));
      return sheetData[`${symbol}:${category}`] ?? null;
    }
    return null;
  }, [prices]);

  /**
   * Portföydeki tüm varlıklar için fiyat güncelleme.
   * Sadece Google Sheets kullanılır.
   */
  const fetchPrices = useCallback(async (portfolio) => {
    if (!portfolio.length) return;
    setLoading(true);

    const { prices: sheetPrices, usdtry: sheetRate, ok } = await fetchAllSheetPrices();
    setSheetOk(ok);
    setPrices((prev) => ({ ...prev, ...sheetPrices }));
    if (sheetRate != null) setUsdtry(sheetRate);
    setLastUpdated(new Date());
    setLoading(false);
  }, []);

  return {
    prices, usdtry, loading, lastUpdated, sheetOk,
    fetchPrices, fetchSinglePrice, getPrice,
  };
};
